import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Grid } from "@material-ui/core";
import DynamicInput from "@icarius-common/dynamicInputs";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";

const DataProtectionDialog = ({ isOpen, onClose, formData, setFormValue, handleSubmit }) => {
  return (
    <Dialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={isOpen}
      scroll={"paper"}
      fullWidth
      maxWidth={"md"}
      onClose={onClose}>
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        {getLocalizedString("dataProtection")}
        <DialogTitleDivider />
      </DialogTitle>
      <CloseIcon className={"dialog-close-icon icon"} onClick={onClose} />
      <DialogContent>
        <Typography style={{ marginBottom: 20 }}>
          {getLocalizedString("rightPannelSwitchIndication")}:
        </Typography>
        <Grid container item xs={12} spacing={2}>
          <Grid container xs={4} item>
            <DynamicInput
              fieldConfig={{ name: "VIS_CELULAR", type: "check", editable: true }}
              label={getLocalizedString("cellphoneVisibleShort")}
              value={formData["VIS_CELULAR"]}
              handleChange={setFormValue}
            />
          </Grid>
          <Grid container xs={4} item>
            <DynamicInput
              fieldConfig={{ name: "VIS_ESTADOCIVIL", type: "check", editable: true }}
              label={getLocalizedString("civilStateVisibleShort")}
              value={formData["VIS_ESTADOCIVIL"]}
              handleChange={setFormValue}
            />
          </Grid>
          <Grid container xs={4} item>
            <DynamicInput
              fieldConfig={{ name: "VIS_FECHANACIMIENTO", type: "check", editable: true }}
              label={getLocalizedString("bornDateVisibleShort")}
              value={formData["VIS_FECHANACIMIENTO"]}
              handleChange={setFormValue}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <ButtonDialogAction
          onClick={onClose}
          text={getLocalizedString("disagree")}
        />
        <ButtonDialogAction
          onClick={handleSubmit}
          isAccept
          text={getLocalizedString("agree")}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DataProtectionDialog;
